import { render, staticRenderFns } from "./TestLanding.vue?vue&type=template&id=a9a2f452&"
import script from "./TestLanding.vue?vue&type=script&lang=js&"
export * from "./TestLanding.vue?vue&type=script&lang=js&"
import style0 from "./TestLanding.vue?vue&type=style&index=0&id=a9a2f452&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports